<template>
  <div class="mt_login_in">
    <img v-show="!isShow" class="loginCut" @click="delu" src="../../assets/imgs/login/iphone.png" alt="">
    <img v-show="isShow" class="loginCut" @click="delu" src="../../assets/imgs/login/erweima.png" alt="">
    <h4>
      <!-- <span :class="isShow ? 'log_act' : false" @click="setWx"
        >使用微信登录飞译</span
      > -->
      <span v-show="isShow" class="log_act">微信登录/注册</span>
      <span v-show="!isShow" class="log_act">手机号/邮箱登录</span>
    </h4>
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="0px" class="ruleForm"
      v-if="!isShow">
      <!-- <p style="float:left">手机号</p> -->
      <el-form-item label prop="loginName">
        <el-input placeholder="手机号/邮箱" v-model="ruleForm.loginName" type="tel"
          @keyup.enter.native="submitForm('ruleForm')">
        </el-input>
      </el-form-item>
      <!-- <p style="float:left">密码</p> -->
      <el-form-item label prop="password">
        <el-input placeholder="密码" type="password" v-model="ruleForm.password" show-password
          @keyup.enter.native="submitForm('ruleForm')"></el-input>
      </el-form-item>
      <dragBox v-if="!isShow" @drag="drag"></dragBox>
      <p style="float:right;margin-top:5px;margin-bottom:10px;cursor:pointer;font-size:12px; margin-bottom: 10px;color:#2270e5;"
        @click="register">忘记密码？
      </p>
      <!-- <el-form-item> -->
      <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
      <!-- </el-form-item> -->
      <p class="register" type @click="goRegis()">没有账号？去注册</p>
    </el-form>
    <div id="wxImg" v-show="isShow">
      <img :src="'data:image/png;base64,' + wxImgSrc" alt="微信二维码" />
      <span v-show="loadingIcon"><i class="el-icon-loading"></i>&nbsp;登录中</span>
      <!-- <span v-show="!loadingIcon">扫码关注中科凡语公众号登录</span> -->
      <div class="upBox" v-if="wxUp" @click="wxRefresh">
        <span>二维码失效，请刷新页面</span>
      </div>
    </div>
  </div>
</template>
<script>
import dragBox from "@/common/dragBox.vue"; // 引入滑动条
import md5 from "js-md5";

export default {
  name: "LoginInEmbed",
  components: {
    dragBox
  },
  data () {
    const checkAge = (rule, value, callback) => {
      if (!value) {
        // console.log(value, "///");
        return callback(new Error("验证码不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (value < 18) {
            callback(new Error("必须年满18岁"));
          } else {
            callback();
          }
        }
      }, 1000);
    };
    const username = (rule, value, callback) => {
      if (this.$privatization) {
        if (!value) {
          return callback(new Error("请填写账号"));
        } else {
          callback();
        }
      } else {
        let reg = /^1\d{10}$/;
        let email = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
        if (!value) {
          return callback(new Error("手机号/邮箱不能为空"));
        }
        if (value.indexOf("@") === -1) {
          if (!reg.test(value)) {
            return callback(new Error("手机号不正确"));
          }
        } else {
          if (!email.test(value)) {
            return callback(new Error("邮箱不正确"));
          }
        }

        callback();
      }

    };
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码长度不能小于6个字符"));
      } else if (value.length > 16) {
        callback(new Error("密码长度不能超过16个字符"));
      }
      callback();
    };
    return {
      ruleForm: {
        loginName: "",
        password: ""
      },
      rules: {
        loginName: [{ required: true, validator: username, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }]
      },
      isShow: true,
      dragOk: false,
      appid: "",
      wxImgSrc: "",
      wxState: "",
      wxInter: null,
      loadingIcon: false,
      wxUp: false
    };
  },
  created () {
    if (process.env.NODE_ENV === "production") {
      this.appid = "wx5bee8f63fa3a45e2"; // 正式环境
    } else {
      this.appid = "wx82c1a47b01583c15";
    }
    this.getWX();
  },
  mounted () {
  },
  beforeDestroy () {
    clearInterval(this.wxInter);
  },
  beforeRouteEnter (to, from, next) {
    if (window.innerWidth > 992 && window.innerWidth < 1366) {
      document.body.style.zoom = 0.8;
    }
    next();
  },
  methods: {
    // 登录
    submitForm (formName) {
      var that = this;

      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.dragOk) {
            this.$message.closeAll();
            this.$message({
              message: "请按住滑块,拖动到最右边!",
              type: "warning"
            });
            return;
          }
          var params = {
            loginName: this.ruleForm.loginName,
            password: md5(this.ruleForm.password)
          };
          this.catReq1Service("/user/login", params).then(function (response) {
            if (!response.success) {
              return;
            }

            var data = response.result;

            var val = JSON.stringify(data);

            if (response.resultCode === "1") {
              // localStorage.setItem("myId", data.id);
              localStorage.setItem("myUser", val);
              localStorage.setItem("myUserImg", data.avatar); // 头像
              localStorage.setItem("myUserName", data.nickName); // 昵称
              localStorage.setItem("myAliasName", data.aliasName); // 别名
              localStorage.setItem("myPhone", data.loginPhone); // 电话
              localStorage.setItem("myEmail", data.email); // 邮箱

              localStorage.setItem("myCompanyCode", data.selfCompany.code); // 公司编码
              // that.$router.push({ name: "home" }); // 跳到首页
              that.$store.state.rou = true;

              that.$router.replace({ name: "home" }); // 跳到首页
            } else {
              that.$message.error(response.errorDesc);
            }
          });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    // 跳注册 忘记密码
    register () {
      this.$router.replace({ name: "login_in", params: { current: 2 } });
      // this.$router.push({ name: "login_up" });
    },
    // 刷新页面
    wxRefresh () {
      this.$router.push({ name: "login_in" });
      // this.$router.go(0);
    },
    // 注册
    goRegis () {
      this.$router.replace({ name: "login_in", params: { current: 1 } });
    },
    getUser () {
      // 判断用户是否关联手机号
      let myPhone = localStorage.getItem("myPhone");
      let myEmail = localStorage.getItem("myEmail");
      this.loadingIcon = false;
      if (myPhone !== "" || myEmail !== "") {
        this.$router.replace({ name: "home" }); // 跳到首页
      } else {
        // this.$router.replace({ name: "relation", params: { userId: "123" } });
        this.$router.replace({ name: "login_in", params: { current: 4 } });
      }
    },
    // 二维码登录
    wxLogin (data) {
      localStorage.setItem("openid", data);
      let that = this;
      this.loadingIcon = true;
      this.catReq1Service("/user/loginByOpenId", { openId: data }).then(
        function (response) {
          if (!response.success) {
            return;
          }
          var data = response.result;
          var val = JSON.stringify(data);
          localStorage.setItem("myUser", val);
          if (response.resultCode === "1") {
            localStorage.setItem("myPhone", data.loginPhone); // 电话
            localStorage.setItem("myId", data.selfCompany.id);
            localStorage.setItem("myUserImg", data.avatar); // 头像
            localStorage.setItem("myUserName", data.nickName); // 昵称
            localStorage.setItem("myAliasName", data.aliasName); // 别名  --
            localStorage.setItem("myEmail", data.email); // 邮箱
            localStorage.setItem("myCompanyCode", data.selfCompany.code); // 公司编码
            that.getUser(); // 判断用户是否绑定手机号
          }
        }
      );
    },
    /// 轮询 是否扫二维码
    getWXStatus () {
      var that = this;
      this.catReq1Service(
        "/wechat/get_openId",
        { state: this.wxState },
        "post",
        2
      ).then(function (response) {
        if (response.resultCode == "0") {
          that.wxUp = true;
          clearInterval(that.wxInter);
          return;
        }
        let data = response.result;

        if (data != null) {
          if (data.resultCode === "0") {
            clearInterval(that.wxInter);
            if (data.errorDesc === "用户无权登陆") {
              that.$message.closeAll();
              that.$message({
                message: "暂无登录权限，请联系管理员。或飞译官方客服：13717630007",
                type: "warning"
              });
              that.getWX();
              return
            }
            that.wxUp = true;
          } else {
            clearInterval(that.wxInter);
            that.wxLogin(data.result.openId);

          }
        }
      });
    },
    // 获取二维码
    getWX () {
      let that = this;
      this.isShow = true;
      this.catReq1Service("/wechat/get_wechat_login_url").then(function (
        response
      ) {
        if (!response.success) {
          return;
        }
        that.wxImgSrc = response.result.urlBase64;
        that.wxState = response.result.state;
        // that.getWXStatus();
        that.wxInter = window.setInterval(that.getWXStatus, 1000);
      });
    },
    /// 微信扫码
    setWx () {
      this.isShow = true;
    },

    // 滑动条事件
    drag (data) {
      this.dragOk = data;
    },
    delu () {
      if (this.isShow) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.mt_login_in {
  text-align: center;
  width: 91%;
  // height: 113%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 10px 10px 0px rgba(137, 137, 137, 0.13);
  border-radius: 10px;
  padding: 2.5vw 1vw;
  position: relative;
  // top: -10px;
  .loginCut {
    position: absolute;
    top: 0px;
    right: 0px;
    cursor: pointer;
  }
  h4 {
    font-size: 16px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    padding: 0 10px;
    margin-bottom: 1vw;
    span:nth-child(1) {
      // float: left;
      text-align: center;
    }
    // span:nth-child(2) {
    //   // float: right;
    // }
    .log_act {
      font-weight: bold;
      color: #1a366c;
      font-size: 18px;
    }
  }
  .ruleForm {
    text-align: center;
    width: 86%;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    margin: 0 auto;
    p {
      margin-bottom: 5px;
      position: relative;
      // right: 34px;
    }
    /deep/.el-input__inner {
      width: 100% !important;
      height: 36px;
      line-height: 36px;
      border: 1px solid rgba(192, 192, 192, 1);
      border-radius: 2px;
    }
    button {
      width: 100%;
      height: 36px;
      background: #2270e5;
      border-radius: 2px;
      line-height: 0px;
      margin-bottom: 10px;
    }
    .register {
      font-size: 12px;
      float: right;
      cursor: pointer;
      color: #2270e5;
      // height: 27px;
      // line-height: 27px;
      // background: rgba(255, 255, 255, 1);
      // border: 1px solid rgba(192, 192, 192, 1);
    }
    .el-form-item {
      margin-bottom: 21px;
    }
  }
  .weixing {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    p {
      position: relative;
      top: 10px;
      left: -40px;
      font-size: 12px;
    }
  }

  #wxImg {
    min-height: 10vw !important;
    margin-top: 20px;
    width: 10vw !important;
    margin: 0 auto;
    position: relative;
    border: 1px solid #999999;
    padding: 1px;
    .upBox {
      position: absolute;
      width: 97%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      height: 90%;
      background: rgba(255, 255, 255, 0.9);
      z-index: 50;
      cursor: pointer;
      font-weight: 600;
      span {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    img {
      // margin-top: 20px;
      width: 100%;
      height: 100%;

      border-radius: 4px;
    }
    span {
      font-size: 18px;
      width: 100%;
      text-align: center;
    }
    i {
      font-size: 20px;
    }
  }
}
.handler_bg {
  width: 30px;
}
/deep/.el-form-item__content {
  width: 100%;
}
// /deep/.drag {
//   max-height: 36px;
//   width: 100%;
//   margin-left: 20px;
//   font-size: 12px;
// }
/deep/.el-form-item__error {
  left: 20px;
}
</style>
<style lang="less">
#wx_default_tip {
  display: none;
}
.status_browser {
  display: none;
}
</style>
